import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CalendarOptions, FullCalendarComponent } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import momentPlugin from '@fullcalendar/moment';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import timeGridPlugin from '@fullcalendar/timegrid';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import * as _ from 'lodash';
import * as moment from 'moment';
import { forkJoin, Observable, Subject } from 'rxjs';
import { delay, map, mergeMap, takeUntil, tap } from 'rxjs/operators';
import { AppModulesType } from '../../../../_shared/enums/appModulesType.enum';
import { ReservationMode } from '../../../../_shared/enums/reservationMode.enum';
import { ActiveModulesService } from '../../../../_shared/services/activeModules.service';
import { HelperMedicalService } from '../../../../_shared/services/helper-medical.service';
import { Helpers } from './../../../../helpers';
import { CusomerCreatedFromType } from './../../../../_shared/enums/customer/cusomerCreatedFromType.enum';
import { EventActions } from './../../../../_shared/enums/eventActions.enum';
import { Asset } from './../../../../_shared/model/asset.model';
import { Contractor } from './../../../../_shared/model/contractor.model';
import { Customer } from './../../../../_shared/model/customer.model';
import { Event } from './../../../../_shared/model/event.model';
import { FcEvent } from './../../../../_shared/model/fcEvent.model';
import { InputEventData } from './../../../../_shared/model/inputEventData.model';
import { ReservationRequest } from './../../../../_shared/model/reservationRequest.model';
import { Case } from './../../../../_shared/model/schedule/case.model';
import { EmptySlot } from './../../../../_shared/model/schedule/empty-slot.model';
import { EventReturn } from './../../../../_shared/model/schedule/eventReturn.model';
import { HolidayEvent } from './../../../../_shared/model/schedule/holidayEvent.model';
import { Resource } from './../../../../_shared/model/schedule/resource.model';
import { Service } from './../../../../_shared/model/service.model';
import { CalendarEvent } from './../../../../_shared/model/settings/calendarEvent.model';
import { Subcontractor } from './../../../../_shared/model/subcontractor.model';
import { User } from './../../../../_shared/model/user.model';
import { CalendarUserGuiSettings } from './../../../../_shared/model/userGuiSettings/calendarUserGuiSettings.model';
import { GuiUserContractorSettings } from './../../../../_shared/model/userGuiSettings/guiUserContractorSettings.model';
import { ActionsService } from './../../../../_shared/services/actions.service';
import { HelperService } from './../../../../_shared/services/helper.service';
import { MfToastService } from './../../../../_shared/services/mfToast.service';
import { StorageService } from './../../../../_shared/services/storage.service';
import { SetCalendarFilter, SetCalendarSubcontractors } from './../../../../_shared/state/base/base.actions';
import { BaseState } from './../../../../_shared/state/base/base.state';
import { TermPopupComponent } from './../../../components/term-popup/term-popup.component';
import { CommonService } from './../_services/common.service';
import { ReservationService } from './../_services/reservation.service';
import { SettingsService } from './../_services/settings.service';
import { VisitService } from './../_services/visit.service';
import { MainCalSlotPopupComponent } from './main-cal-slot-popup/main-cal-slot-popup.component';
import { MainCalendarGuiService } from './main-calendar.gui.service';
import { MainCalendarHelperService } from './main-calendar.helper.service';

// TODO Ignored with eslint-interactive on 2023-11-10
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $: any;
@Component({
    selector: 'main-calendar',
    templateUrl: './main-calendar.component.html',
    styleUrls: ['./main-calendar.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MainCalendarComponent implements OnInit {
    @ViewChild('calendar', { static: false }) public calendarComponent: FullCalendarComponent;

    @Select(BaseState.GetUserSettings)
    userSettings: Observable<GuiUserContractorSettings>;

    @Input()
    isCase?: boolean;

    @Input()
    canOpenTerm = true;

    @Input()
    canAddNewTerms = true;

    @Input()
    isPopupMode = false;

    @Input()
    highlightTerm: Event;

    @Input()
    isReschedule = false;

    @Input()
    isCreateFromWaitingQueue = false;

    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    genericData: any;

    @Input()
    selectedCustomerForNewTerm: Customer;

    @Input()
    isGetOnlySlot = false;

    @Input()
    connectTermWithWorkOrder = false;

    // @Input()
    // limitToSubcontractors: any[];

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    changedTerm: EventEmitter<any>;

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    onClosePopup: EventEmitter<Event | EmptySlot>;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public settings: CalendarUserGuiSettings | any;
    public allAssets: Asset[];
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public holidays: any[];
    public allSubcontractors: Subcontractor[];
    public isCollapsed = true;
    // public slotDuration: any = '00:30:00';
    private onDestroy$ = new Subject<void>();
    public praznik = 'Prazniki';
    public fetchingResources = false;
    public rendered = false;
    public allEventsCount = 0;
    public popupOpened = false;
    public defaultView = 'timeGridWeek';
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public defaultDate: any;
    public loggedUser: User;
    public isSettingsLoaded = false;
    public calendarEditable = true;
    public selectedFilterCustomer: Customer;

    public calendarHeader = {
        //check če imaš priklopljeno razpoložljivost
        left: 'prev,next,today,prevYear,nextYear',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth',
    };
    public groupsData;
    private textSearch: string;
    public calendarSettings: CalendarOptions = {
        dayMaxEvents: true,
        schedulerLicenseKey: '0859267262-fcs-1533401669',
        slotDuration: '00:30:00', //default
        initialView: 'timeGridWeek',
        slotLabelFormat: 'HH:mm',
        eventTimeFormat: 'HH:mm',
        headerToolbar: this.calendarHeader,
        buttonText: {
            today: 'Danes',
            month: 'Mesec',
            week: 'Teden',
            day: 'Dan',
            list: 'Seznam',
        },
        height: 'parent',
        views: {
            basic: {},
            agenda: {},
            day: {
                titleFormat: 'dddd DD. MM. YYYY',
            },
            agendaWeek: {},
        },
        weekends: true,
        locale: 'sl',
        // loading: this.loading.bind(this),
        timeZone: 'local',
        firstDay: 1,
        refetchResourcesOnNavigate: true,
        selectable: true,
        slotEventOverlap: true,
        nowIndicator: true,
        datesAboveResources: true,
        initialDate: moment().toDate(),
        aspectRatio: 1,
        plugins: [dayGridPlugin, timeGridPlugin, momentPlugin, interactionPlugin, resourceTimeGridPlugin, listPlugin, resourceTimelinePlugin],
        editable: this.calendarEditable,
        // allDaySlot: this.settings?.filter?.showHolidays,
        allDayText: 'praznik',
        contentHeight: this.contentHeightCalc.bind(this),
        // buttonIcons: {
        //     prev: 'left-single-arrow',
        //     next: 'right-single-arrow',
        //     prevYear: 'left-double-arrow',
        //     nextYear: 'right-double-arrow',
        // },
        // slotMinTime: this.settings?.filter?.from,
        // slotMaxTime: this.settings?.filter?.to,
        datesSet: this.saveCalendarRange.bind(this),
        select: this.onSelect.bind(this),
        eventClick: this.eventClick.bind(this),
        eventResize: this.onEventEdit.bind(this),
        eventDrop: this.onEventMove.bind(this),
        eventClassNames: this.onEventRenderSetClassName.bind(this),
        // eventContent: this.onEventRender2.bind(this), //eventRender
        eventDidMount: this.onEventRender.bind(this), //eventRender
        // resourceLabelContent: this.onEventResourceRender.bind(this),
        // resourceLaneContent: this.onEventResourceRender.bind(this),
        eventDragStart: this.removePopover.bind(this),
        eventDragStop: this.removePopover.bind(this),
        events: this.getEvents.bind(this),
        resources: this.getResources.bind(this),
        resourceLabelDidMount: this.onEventResourceRender.bind(this),

        // resourceAreaHeaderContent: this.onEventResourceRender.bind(this),
    };
    constructor(
        private guiHelper: MainCalendarGuiService,
        private commonRest: CommonService,
        private storage: StorageService,
        private settingsRest: SettingsService,
        private helper: HelperService,
        private reservatioRest: ReservationService,
        private modalService: NgbModal,
        public toastr: MfToastService,
        private route: Router,
        private store: Store,
        private localHelper: MainCalendarHelperService,
        private visitRest: VisitService,
        private decimalPipe: DecimalPipe,
        private actions: ActionsService,
        private am: ActiveModulesService,
        private mta: HelperMedicalService,
    ) {
        this.changedTerm = new EventEmitter();
        this.onClosePopup = new EventEmitter();
    }

    ngOnInit() {
        this.actions.onStartContractorChange.subscribe(() => (this.isSettingsLoaded = false));
        // this.actions.onEndContractorChange.subscribe(() => this.ngOnInit());
        this.isSettingsLoaded = false;
        //default ali shranjeni start koledarja
        this.loggedUser = this.storage.getUserData();
        // this.defaultDate = _.get(this.loggedUser, 'settings.calendarFrom', moment().toDate());
        this.calendarEditable = !this.storage.getUserRoles().includes('ROLE_RESTRICTED_SUBCONTRACTOR');
        this.localHelper.loadServicesToCache().pipe(takeUntil(this.onDestroy$)).subscribe();
        //začetni podatki iz baze ob kreiranju koledarja
        if (_.get(this.storage.getContractorSettings(), 'booking.bookingTypes', []).includes('groups')) {
            //če imajo vključeno bookiranje za skupine -> zlovdaj vse skupine storitev
            this.settingsRest
                .getContractorServiceGroups(this.storage.getSelectedContractor().id)
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(groups => {
                    this.groupsData = groups;
                });
        }
        forkJoin({
            assets: this.commonRest.getAllAssets(this.storage.getSelectedContractor().id),
            subContractors: this.commonRest.getAllSubcontractors(this.storage.getSelectedContractor().id, true),
        })
            .pipe(
                takeUntil(this.onDestroy$),
                tap(data => {
                    // this.calendarSettings = ;
                    this.settings = _.cloneDeep(this.store.selectSnapshot(BaseState.GetUserSettings).calendar);
                    this.setCalendarSettings();
                    this.allAssets = data.assets;
                    this.allSubcontractors = data.subContractors;
                    this.selectSubcontractorsInFilter();
                    this.store.dispatch(new SetCalendarSubcontractors(this.settings?.subconstractors));
                    this.setHeader();
                    //če imaš izklopljene vse prostore ob zagonu jih vklopi
                    if (!this.settings.filter.selectedAssets || this.settings.filter.selectedAssets.length === 0) {
                        const filter = _.cloneDeep(this.settings.filter);
                        filter.selectedAssets = this.allAssets;
                        this.store.dispatch(new SetCalendarFilter(filter));
                    }
                }),
                mergeMap(() =>
                    this.store.select(BaseState.GetUserSettings).pipe(
                        takeUntil(this.onDestroy$),
                        tap((res: GuiUserContractorSettings) => {
                            this.settings = _.cloneDeep(res.calendar);
                            this.setCalendarSettings();
                        }),
                        tap(() => {
                            if (!_.isNil(this.calendarComponent) && this.isSettingsLoaded) {
                                this.setHeader();
                                const calendarApi = this.calendarComponent.getApi();
                                const currentView = calendarApi.view.type;
                                //razpolozljivost
                                if (_.get(this.settings, 'filter.showResources', false)) {
                                    if (currentView === 'listMonth' || currentView === 'dayGridMonth') {
                                        return;
                                    }
                                    if (currentView === 'timeGridWeek') {
                                        calendarApi.changeView('resourceTimeGridWeek');
                                    } else if (currentView === 'timeGridDay') {
                                        calendarApi.changeView('resourceTimeGridDay');
                                    }
                                    this.reloadEvents();
                                } else {
                                    if (currentView === 'timeGridWeek' || currentView === 'resourceTimeGridWeek') {
                                        calendarApi.changeView('timeGridWeek');
                                    } else if (currentView === 'timeGridDay' || currentView === 'resourceTimeGridDay') {
                                        calendarApi.changeView('timeGridDay');
                                    } else if (currentView === 'dayGridMonth') {
                                        return;
                                    }
                                    this.reloadEvents(true, false);
                                }
                                // this.settingsManager();
                            }
                        }),
                        delay(120),
                    ),
                ),
            )

            .subscribe(() => {
                this.isSettingsLoaded = true;
            });
    }

    public onCustomerSelected(customer: Customer): void {
        this.selectedFilterCustomer = customer;
    }

    private setCalendarSettings(): void {
        this.calendarSettings.slotMinTime = this.settings?.filter?.from;
        this.calendarSettings.slotMaxTime = this.settings?.filter?.to;
        this.calendarSettings.allDaySlot = this.settings?.filter?.showHolidays;
        this.calendarSettings.slotDuration = '00:' + this.decimalPipe.transform(_.get(this.settings, 'timeFrequency', 30), '2.0') + ':00';
        this.calendarSettings.weekends = this.settings.filter.showWeekend;
        this.calendarSettings.initialView = this.loggedUser?.settings?.selectedCalendarView || 'timeGridWeek';
        this.calendarSettings.initialDate = <Date>_.get(this.loggedUser, 'settings.calendarFrom', moment().toDate());
        if (_.get(this.settings, 'filter.showResources', false)) {
            if (this.calendarSettings.initialView == 'timeGridWeek') {
                this.calendarSettings.initialView = 'resourceTimeGridWeek';
            } else if (this.calendarSettings.initialView == 'timeGridDay') {
                this.calendarSettings.initialView = 'resourceTimeGridDay';
            }
            this.calendarHeader.right = 'dayGridMonth,resourceTimeGridWeek,resourceTimeGridDay,listMonth';
        } else {
            this.calendarHeader.right = 'dayGridMonth,timeGridWeek,timeGridDay,listMonth';
        }
    }
    public setHeader() {
        //v primeru da imamo vključeno razpoložljivost, moramo spremeniti header
        // da namesto timeGridWeek --> resourceTimeGridWeek
        if (this.calendarComponent) {
            this.calendarHeader.right = _.get(this.settings, 'filter.showResources')
                ? 'dayGridMonth,resourceTimeGridWeek,resourceTimeGridDay,listMonth'
                : 'dayGridMonth,timeGridWeek,timeGridDay,listMonth';

            const calendarApi = this.calendarComponent.getApi();
            calendarApi.setOption('headerToolbar', this.calendarHeader);
        }
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public loading(isLoading: any): void {
        if (isLoading) {
            this.disableButtons(true);
            this.rendered = false;
            Helpers.setLoading(true);
        } else {
            this.disableButtons(false);
            this.rendered = true;
            Helpers.setLoading(false);
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }
    public selectSubcontractorsInFilter() {
        //če je bil subcontractor izbrisan na adminu in ni bil osvežen filter
        if (!_.isNil(this.allSubcontractors) && !_.isNil(this.settings.subconstractors)) {
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const filterSub: any[] = this.settings.subconstractors.map(sub => sub.id);
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const allSub: any[] = this.allSubcontractors.map(sub => sub.id);
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const intersection: any[] = _.intersection(filterSub, allSub);
            // if (intersection.length < this.settings.subconstractors.length) {
            //odstani zbrisne subcontractorje iz filtrov
            this.settings.subconstractors = this.allSubcontractors.filter(sub => intersection.includes(sub.id));
            // this.reloadEvents();
            // }
        }
    }

    public getEvents(data) {
        this.removePopover();
        const start: moment.Moment = moment(data.start);
        const end: moment.Moment = moment(data.end);
        this.allEventsCount = 0;
        this.loading(true);

        return this.loadData(start, end)
            .pipe(tap(() => this.loading(false)))
            .toPromise();
    }

    // public getResources = (data) => {
    public getResources(data) {
        this.removePopover();
        //ne moreta biti 2 getResources klica hkrati
        if (this.fetchingResources) {
            this.fetchingResources = false;
            return;
        } else {
            this.fetchingResources = true;
        }
        const start: moment.Moment = moment(data.start);
        const end: moment.Moment = moment(data.end);
        // Izklopljena razpoložljivost -> ne rabiš resoursev
        if (!this.settings.filter.showResources) {
            this.fetchingResources = false;
            return new Promise(resolve => {
                resolve([]);
            });
        }
        // Brez izbranega podizvajalca -> ne rabiš resoursev
        if (_.get(this.settings, 'subconstractors.length', 0) < 1) {
            this.fetchingResources = false;
            return new Promise(resolve => {
                resolve([]);
            });
        }
        //API klic da lahko narišemo background evente
        this.loadWorkingHours(this.settings.subconstractors, start, moment(end).subtract(1, 'day'))
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(res => {
                // Filter: Prikaži samo razpoložljive podizvajalce
                if (
                    this.settings.filter.showOnlyAvailable &&
                    this.calendarComponent.getApi().view.type !== 'dayGridMonth' &&
                    this.calendarComponent.getApi().view.type !== 'listMonth'
                ) {
                    res = this.removeNonWorkingSubContractors(res);
                }
                //filtriraj po 2 vrstah zunanjih razpoložljivosti
                if (
                    this.settings.filter.showExternalAvailable &&
                    this.settings.filter.showExternalCustomerAvailable &&
                    this.calendarComponent.getApi().view.type !== 'dayGridMonth' &&
                    this.calendarComponent.getApi().view.type !== 'listMonth'
                ) {
                    res = this.removeExternalAvailability(res);
                    res = this.removeExternalCustomerAvailability(res);
                } else if (
                    this.settings.filter.showExternalAvailable &&
                    !this.settings.filter.showExternalCustomerAvailable &&
                    this.calendarComponent.getApi().view.type !== 'dayGridMonth' &&
                    this.calendarComponent.getApi().view.type !== 'listMonth'
                ) {
                    res = this.removeExternalAvailability(res, true);
                } else if (
                    !this.settings.filter.showExternalAvailable &&
                    this.settings.filter.showExternalCustomerAvailable &&
                    this.calendarComponent.getApi().view.type !== 'dayGridMonth' &&
                    this.calendarComponent.getApi().view.type !== 'listMonth'
                ) {
                    res = this.removeExternalCustomerAvailability(res, true);
                }
                //Resetiraj background evente, ker koledar ne naredi tega avtomatsko
                this.resetAllBackgroundEvents();
                //Nariši background evente
                this.loadBackgroundColorForResorceWH(res, start.clone(), end.clone());
                //Resetiraj vse calendar resource in dodaj nove
                this.resetAndRerenderAllResources(res);
                this.fetchingResources = false;
                this.disableButtons(false);
                return new Promise(resolve => {
                    resolve(res);
                });
            });
    }

    public resetAllBackgroundEvents() {
        // Če ima event rendering === 'background' potem prikazuje razpoložljivost
        const calendarApi = this.calendarComponent.getApi();
        if (calendarApi.view.type === 'listMonth' || calendarApi.view.type === 'dayGridMonth') {
            return;
        }
        const allEvents = calendarApi.getEvents();
        calendarApi.batchRendering(function () {
            allEvents.forEach(event => {
                if (event?.display == 'background') {
                    event.remove();
                }
            });
        });
    }

    public removePopover() {
        //remove popup od eventa
        $('.popover').remove();
        //remove popup od podizvajalca
        $('.tooltip-inner').remove();
        $('.arrow').remove();
    }

    public disableButtons(state) {
        //TODO boljša rešitev
        $('.fc-prev-button').prop('disabled', state);
        $('.fc-next-button').prop('disabled', state);
        // $('.fc-today-button').prop('disabled', state); ostati mora zakomentiran
        $('.fc-dayGridMonth-button').prop('disabled', state);
        $('.fc-resourceTimeGridWeek-button').prop('disabled', state);
        $('.fc-resourceTimeGridDay-button').prop('disabled', state);
        $('.fc-listMonth-button').prop('disabled', state);
        $('.fc-timeGridWeek-button ').prop('disabled', state);
        $('.fc-timeGridDay-button').prop('disabled', state);
    }

    public resetAndRerenderAllResources(res) {
        const calendarApi = this.calendarComponent.getApi();
        const allResources = calendarApi.getResources();
        if (calendarApi.view.type === 'listMonth' || calendarApi.view.type === 'dayGridMonth') {
            return;
        }
        calendarApi.batchRendering(function () {
            allResources.forEach(resource => {
                const removedResource = calendarApi.getResourceById(resource.id);
                removedResource.remove();
            });
        });

        calendarApi.batchRendering(function () {
            res.map(resource => {
                resource.hours = resource.businessHours;
                calendarApi.addResource(resource);
            });
        });
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public loadHolidays(start: moment.Moment): Observable<any> {
        return this.reservatioRest.getHolidays(start.format('YYYY')).pipe(map(el => el.holidays));
    }
    public createHolidayEvents(holdidays): CalendarEvent[] {
        return holdidays.map((el: HolidayEvent) => {
            return new CalendarEvent().deserialize({
                allDay: true,
                start: el.holidayDate,
                title: el.name,
                editable: false,
                resourceIds: this.allSubcontractors.map(el => el.id),
                backgroundColor: '#972CF0',
                textColor: '#ffffff',
                end: el.holidayDate,
                data: new HolidayEvent().deserialize(el),
            });
        });
    }
    public contentHeightCalc() {
        return window.innerHeight - 136;
    }
    public onEventMove(event: InputEventData): void {
        this.removePopover();
        if (_.get(event, 'event.extendedProps.data.visitId')) {
            //onemogoči urejanje obravnav
            return;
        }
        //update start + konec
        event.event.extendedProps.data.start = moment(event.event.start);
        event.event.extendedProps.data.end = moment(event.event.end);
        //vključen prikaz razpoložljivosti + premikaš termin med podizvajalci
        if (_.get(event, 'newResource.id')) {
            event.event.extendedProps.data.newResource = {
                id: Number(_.get(event, 'newResource.id')),
                name: _.get(event, 'newResource.title'),
            };
        }
        if (event.event.extendedProps.data.recurringId) {
            event.event.extendedProps.data.oldEvent = event.oldEvent;
        }
        this.updateEvent(event.event);
    }
    public onEventEdit(event: InputEventData): void {
        this.removePopover();
        //update konec termina ko raztegneš(drag) event dol v koledarju
        event.event.extendedProps.data.end = moment(event.event.end);
        this.updateEvent(event.event);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onSelect(data: any): void {
        //ni nobenih eventov na koledarju
        if (this.rendered && this.settings.filter.showOnlyAvailable && this.allEventsCount == 0) {
            return;
        }
        //nimaš izbranih podizvajalcev
        if (!_.get(this.settings, 'subconstractors.length', 0)) {
            return;
        }
        //če klikneš na praznik --> ne sme odpret popupa
        if (data.allDay) {
            return;
        }
        //nimaš pravic
        if (!this.calendarEditable) {
            return;
        }
        //blokirano dodajanje terminov
        if (!this.canAddNewTerms) {
            return;
        }

        if (this.isGetOnlySlot) {
            // this.onClosePopup.emit(data.startStr);

            const modalNewTerm: NgbModalRef = this.modalService.open(MainCalSlotPopupComponent, {
                backdrop: 'static',
                keyboard: false,
                windowClass: 'mf-transparent-popup mf-gray-background-popup mf-screen-height-popup mf-popup-with__title',
            });
            modalNewTerm.componentInstance.event = new FcEvent().deserialize({
                resourceId: data?.resource?.id,
                start: data.start,
                end: data.end,
            });
            modalNewTerm.result.then((value: EmptySlot) => {
                this.onClosePopup.emit(value);
            });
            return;
        }
        //normalno
        if (data.start) {
            this.selectEmpty(
                new CalendarEvent().deserialize({
                    start: data.start,
                    end: data.end,
                    data: { reservationMode: ReservationMode.RESERVE },
                }),
                new Resource().deserialize({
                    id: _.get(data, 'resource.id'),
                    businessHours: _.get(data, 'resource.extendedProps.hours'),
                }),
            );
        }
    }

    public selectEmpty(model: CalendarEvent, resource: Resource) {
        this.openDialog(model, false, new Resource().deserialize(resource));
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public loadData(start, end): Observable<any[]> {
        let allEvents: CalendarEvent[] = [];
        const allSubcontractorsApis = this.settings?.subconstractors.map(subcon => {
            return this.reservatioRest.getReservationList(
                _.get(this.storage.getSelectedContractor(), 'id', -1),
                subcon.id,
                start.format('YYYY-MM-DD'),
                end.format('YYYY-MM-DD'),
            );
        });
        if (allSubcontractorsApis.length === 0) {
            return this.loadHolidays(start).pipe(
                map(data => {
                    return this.createHolidayEvents(data);
                }),
            );
        } else {
            return forkJoin([...allSubcontractorsApis]).pipe(
                takeUntil(this.onDestroy$),
                mergeMap(
                    () => this.loadHolidays(start),
                    // TODO Ignored with eslint-interactive on 2023-11-10
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (subcontractors: any[], holdidays: HolidayEvent[]) => ({
                        holdidays: holdidays,
                        subcontractors: subcontractors,
                    }),
                ),
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                map((el: { holdidays: HolidayEvent[]; subcontractors: any[] }) => {
                    const holdidays = el.holdidays;
                    const subcontractors = _.flatten(el.subcontractors);
                    if (!_.isNil(subcontractors)) {
                        for (const event of subcontractors) {
                            if (event.caseId) {
                                event.case = new Case().deserialize({
                                    caseId: event.caseId,
                                    bsid: event.bsid,
                                    caseInternalId: event.caseInternalId,
                                });
                            }
                            const element = new Event().deserialize(event);
                            if (element.visitId) {
                                element.editable = false;
                            } else {
                                element.editable = true;
                            }

                            if (
                                _.get(this.settings, 'filter.selectedAssets', []).filter(e => e.id == _.get(event, 'asset.id', -1)).length > 0 ||
                                _.get(event, 'asset.id', -1) == -1
                            ) {
                                let data: Service[] = undefined;
                                if (this.settings.filter.showServicesColor) {
                                    //če je skupina --> daj podatke o barvah skupin
                                    if (element.serviceGroup) {
                                        data = this.groupsData;
                                    } else {
                                        data = this.store.selectSnapshot(BaseState.getServices());
                                    }
                                }
                                // TODO Ignored with eslint-interactive on 2023-11-10
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                const calEvent: any = element;
                                _.set(calEvent, 'data', element);
                                _.set(calEvent, 'display', 'block');
                                allEvents.push(new CalendarEvent().deserialize(calEvent, this.settings.subconstractors, data));
                            }
                        }
                        if (!_.isNil(holdidays)) {
                            // allEvents.push(new CalendarEvent().deserialize({
                            //     title:'naslov'
                            // }))
                            allEvents = allEvents.concat(this.createHolidayEvents(holdidays));
                        }
                        return allEvents;
                    } else {
                        if (!_.isNil(holdidays)) {
                            allEvents = allEvents.concat(this.createHolidayEvents(holdidays));
                        }
                        return allEvents;
                    }
                }),
            );
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public updateEvent(model: any) {
        this.openDialog(
            model.extendedProps.data,
            true,
            model.resourceId != model.extendedProps.data.contractor.subcontractors[0].id
                ? new Resource().deserialize({ id: model.resourceId })
                : undefined,
        );
    }

    public openDialog(term: CalendarEvent, edit, resource: Resource): void {
        const modalNewTerm: NgbModalRef = this.modalService.open(TermPopupComponent, {
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            windowClass: 'mf-transparent-popup',
        });
        modalNewTerm.componentInstance.isCase = this.isCase;
        modalNewTerm.result.then(
            () => {
                this.removePopover();
                if (this.calendarComponent.getApi()) {
                    //če odpreš in zapreš popup v list/month view --> ne reloadat eventov
                    if (this.calendarComponent.getApi().view.type === 'listMonth' || this.calendarComponent.getApi().view.type === 'dayGridMonth') {
                        return;
                    }
                }
                if (edit) {
                    this.reloadEvents(true, false);
                }
                if (document.querySelector('body > .modal')) {
                    document.body.classList.add('modal-open');
                }
            },
            (newEvent: EventReturn) => {
                this.removePopover();
                if (document.querySelector('body > .modal')) {
                    document.body.classList.add('modal-open');
                }
                switch (newEvent?.action) {
                    case EventActions.EDIT:
                        this.toastr.success('Termin je uspešno spremenjen.');
                        this.changedTerm.emit(newEvent.fcEvent);
                        this.onClosePopup.emit(newEvent?.fcEvent?.data);
                        if (!this.isReschedule) this.reloadEvents(true, false);
                        break;
                    case EventActions.COPY:
                        this.reloadEvents(true, false);
                        break;
                    case EventActions.DELETE:
                        this.reloadEvents(true, false);
                        break;
                    case EventActions.NEW:
                    default:
                        if (newEvent?.fcEvent?.data?.aggregateId) {
                            const calendarApi = this.calendarComponent.getApi();
                            calendarApi.addEvent({
                                start: newEvent.fcEvent.data.start,
                                end: newEvent.fcEvent.data.end,
                                className: newEvent.fcEvent.data.className,
                                backgroundColor: newEvent.fcEvent.backgroundColor,
                                title: String(newEvent.fcEvent.title),
                            });
                            if (newEvent.fcEvent.data.isRecurring || newEvent.fcEvent.data.recurringId || !this.isPopupMode) {
                                this.reloadEvents(true, false);
                            }
                            this.toastr.success('Nov termin je uspešno dodan.');

                            this.onClosePopup.emit(newEvent?.fcEvent?.data);
                        }
                        break;
                }
                if (newEvent?.isOpenReservation && _.has(newEvent, 'fcEvent.data.prereservationId')) {
                    this.navigateToTerm(
                        _.get(newEvent, 'fcEvent.data.prereservationId'),
                        false,
                        _.get(newEvent, 'fcEvent.data.customer.id'),
                        _.get(newEvent, 'fcEvent.data.visitId'),
                        _.get(newEvent, 'fcEvent.data.telemed'),
                        _.get(newEvent, 'fcEvent.data.phoneCall'),
                        _.get(newEvent, 'fcEvent.data.reservationType'),
                        _.get(newEvent, 'fcEvent.data.originUrl'),
                    );
                }
            },
        );
        modalNewTerm.componentInstance.businessHours = resource ? resource.businessHours : undefined;
        if (edit) {
            //urejanje termina
            if (term?.title) {
                //urejanje interne rezervacije
                this.editInternalReservation(modalNewTerm, term, resource);
            } else {
                //urejanje normalne rezervacije
                this.editRegularReservation(modalNewTerm, term, resource);
            }
        } else if (this.isCreateFromWaitingQueue) {
            this.fromWaitingQueueReservation(modalNewTerm, term, resource);
        } else if (this.highlightTerm && this.isReschedule) {
            // premik (urejanje) termina iz kartice termina
            this.rescheduleReservation(modalNewTerm, this.highlightTerm, term);
        } else {
            this.regularReservation(modalNewTerm, term, resource);
        }
    }

    public regularReservation(modalNewTerm: NgbModalRef, term: CalendarEvent, resource: Resource): void {
        // dodajanje novega termina
        const resRequestData: ReservationRequest = new ReservationRequest();
        if (!_.isNil(resource.id)) {
            resRequestData.selectedSubcontractor = _.get(this.settings, 'subconstractors').find(el => el.id == resource.id);
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selectedBH: any = this.localHelper.getSelectedBusinessHours(resource.businessHours, term.start);

            if (_.has(selectedBH, 'assetId') && !_.isNil(selectedBH.assetId)) {
                _.set(resRequestData, 'selectedAsset.id', selectedBH.assetId);
            }
        }
        // poznamo datum
        if (term) {
            resRequestData.selectedDate = moment(term.start);
            resRequestData.selectedTime = moment(term.start).format('HH:mm');
        }

        //če je samo en subcontractor izbran v filtrih ga avtomatsko izberemo
        if (_.get(this.settings, 'subconstractors') && _.get(this.settings, 'subconstractors.length') === 1) {
            resRequestData.selectedSubcontractor = _.get(this.settings, 'subconstractors')[0];
        }
        resRequestData.customerForTerm = this.selectedCustomerForNewTerm;
        resRequestData.reservationMode = ReservationMode.RESERVE;

        if (resRequestData.reservationMode === ReservationMode.RESERVE) {
            resRequestData.popupTitle = 'Dodajanje nove rezervacije';
        } else {
            resRequestData.popupTitle = 'Dodajanje nove obravnave';
        }
        modalNewTerm.componentInstance.resRequestData = resRequestData;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public eventClick(model: any) {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let jsEvent: any;
        this.removePopover();
        if (model.event) {
            jsEvent = model.jsEvent;
            model = model.event;
            if (model.allDay) {
                return;
            }
        }
        if (model.rendering == 'background') {
            return;
        }
        if (this.connectTermWithWorkOrder) {
            //emit prereservationID v oim-order-data componento
            this.helper.displayAlert('Povezovanje termina.', 'Povežem izbrani termin z naročilnico?').then(result => {
                if (result.value) {
                    this.onClosePopup.emit(<Event>model.extendedProps.data);
                }
            });
            return;
        }
        //ce je genericni termin
        if (!this.canOpenTerm && !this.connectTermWithWorkOrder) {
            this.toastr.warning('V tem pogledu odpiranje termina ni mogoče.');
            return;
        }
        if (_.get(model, 'extendedProps.data.reservationMode') === ReservationMode.INTERNAL) {
            //interno
            this.openDialog(model.extendedProps.data, true, undefined);
        } else if (_.get(model, 'extendedProps.data.reservationMode') === ReservationMode.DRAFT) {
            //osnutek
            this.openDialog(model.extendedProps.data, true, undefined);
        } else if (
            !_.get(model, 'extendedProps.data.asset.name') ||
            (!_.get(model, 'extendedProps.data.service.name') && !_.get(model, 'extendedProps.data.serviceGroup.name')) ||
            !_.get(model, 'extendedProps.data.customer.name') ||
            _.get(model, 'extendedProps.data.isRecurring', false)
        ) {
            //prikažemo popup če nimamo vseh podatkov + če je ponavljajoč
            this.openDialog(model.extendedProps.data, true, undefined);
        } else if (model?.extendedProps?.data?.customer?.createdFrom == CusomerCreatedFromType.PATIENT_APP) {
            //ce je zacasna stranka
            this.localHelper.findSimilarCustomers(model?.extendedProps?.data);
        } else {
            // dobimo podatek ce je zakljucen
            if (model.extendedProps.data.visitId) {
                this.visitRest
                    .isVisitConcluded(this.storage.getSelectedContractor().id, model.extendedProps.data.visitId)
                    .pipe(takeUntil(this.onDestroy$))
                    .subscribe(res => {
                        model.extendedProps.data.isConcluded = res; // == 'true';
                        this.storage.setSelectedTerm(model.extendedProps.data);
                        this.navigateToTerm(
                            model.extendedProps.data.prereservationId,
                            jsEvent.ctrlKey || jsEvent.metaKey,
                            model._def.extendedProps.data.customer.id,
                            model._def.extendedProps.data.visitId,
                            model._def.extendedProps.data.phoneCall,
                            model._def.extendedProps.data.telemed,
                            model.extendedProps.data.reservationType,
                            model.extendedProps.data.originUrl,
                        );
                    });
            } else {
                if (_.isNil(model.extendedProps.data.recurringId)) {
                    this.storage.setSelectedTerm(model.extendedProps.data);
                    this.navigateToTerm(
                        model.extendedProps.data.prereservationId,
                        jsEvent.ctrlKey || jsEvent.metaKey,
                        model._def.extendedProps.data.customer.id,
                        model._def.extendedProps.data.visitId,
                        model._def.extendedProps.data.phoneCall,
                        model._def.extendedProps.data.telemed,
                        model.extendedProps.data.reservationType,
                        model.extendedProps.data.originUrl,
                    );
                } else {
                    //ustvarimo rezervacijo mato preusmerimo na terminđ
                    this.localHelper
                        .createSimpleReservation(model.extendedProps.data)
                        .pipe(takeUntil(this.onDestroy$))
                        .subscribe(res => {
                            const tmpPrereservation = model.data.prereservationId;
                            model.extendedProps.data.prereservationId = res.prereservationId;
                            model.extendedProps.data.additionalPrereservationId = tmpPrereservation;
                            this.storage.setSelectedTerm(model.extendedProps.data);
                            this.navigateToTerm(
                                model.extendedProps.data.prereservationId,
                                jsEvent.ctrlKey || jsEvent.metaKey,
                                model._def.extendedProps.data.customer.id,
                                model._def.extendedProps.data.visitId,
                                model._def.extendedProps.data.phoneCall,
                                model._def.extendedProps.data.telemed,
                                model.extendedProps.data.reservationType,
                                model.extendedProps.data.originUrl,
                            );
                        });
                }
            }
        }
    }

    private rescheduleReservation(modalNewTerm: NgbModalRef, term: Event, fcTerm: CalendarEvent): void {
        const resRequestData: ReservationRequest = new ReservationRequest();
        resRequestData.reservationMode = ReservationMode.RESERVE;

        resRequestData.event = term;
        const lengthOfTerm = moment.duration(moment(term.end).diff(moment(term.start))).asMinutes();
        resRequestData.isEditMode = true;
        resRequestData.selectedDate = moment(fcTerm.start);
        resRequestData.selectedTime = moment(fcTerm.start).format('HH:mm');
        resRequestData.selectedTimeEnd = moment(fcTerm.start).clone().add(lengthOfTerm, 'minutes').format('HH:mm');
        resRequestData.customerForTerm = new Customer().deserialize(term.customer);
        resRequestData.customTagId = term.customTagId;

        resRequestData.popupTitle = 'Urejanje rezervacije';

        if (!_.isNil(term.asset)) {
            resRequestData.selectedAsset = _.get(term, 'asset');
        }

        resRequestData.termComment = term.comment;
        resRequestData.selectedSubcontractor = _.get(term, 'contractor.subcontractors[0]', undefined);
        if (_.get(term, 'serviceGroup')) {
            resRequestData.serviceGroup = _.get(term, 'serviceGroup', undefined);
        } else {
            resRequestData.selectedService = _.get(term, 'service', undefined);
        }
        modalNewTerm.componentInstance.resRequestData = resRequestData;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private fromWaitingQueueReservation(modalNewTerm: NgbModalRef, term: CalendarEvent, resource: any): void {
        // dodajanje novega termina
        const resRequestData: ReservationRequest = new ReservationRequest();
        if (!_.isNil(resource.id)) {
            resRequestData.selectedSubcontractor = this.settings.subconstractors.find(el => el.id == resource.id);
            // predizberi podizvajalca
            modalNewTerm.componentInstance.selectedSubcontractor = this.settings.subconstractors.find(el => el.id == resource.id);
        }
        // poznamo datum
        if (term) {
            resRequestData.selectedDate = moment(term.start);
            resRequestData.selectedTime = moment(term.start).format('HH:mm');
        }
        //ce je samo en subcontractor ga izberemo
        if (_.get(this.settings, 'filter.selectedSubcontractors') && _.get(this.settings, 'filter.selectedSubcontractors.length') === 1) {
            resRequestData.selectedSubcontractor = _.get(this.settings, 'filter.selectedSubcontractors')[0];
        }
        resRequestData.customerForTerm = this.highlightTerm.customer;
        resRequestData.reservationMode = ReservationMode.QUEUE;
        resRequestData.popupTitle = 'Dodajanje nove rezervacije iz čakalne vrste';
        resRequestData.event = this.highlightTerm;
        resRequestData.selectedService = this.highlightTerm.service;
        modalNewTerm.componentInstance.resRequestData = resRequestData;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private editInternalReservation(modalNewTerm: NgbModalRef, term: any, resource: any): void {
        const resRequestData: ReservationRequest = new ReservationRequest();
        resRequestData.event = term;
        resRequestData.reservationMode = ReservationMode.INTERNAL;
        resRequestData.isEditMode = true;
        resRequestData.selectedDate = moment(term.start);
        resRequestData.selectedTime = moment(term.start).format('HH:mm');
        resRequestData.selectedTimeEnd = moment(term.end).format('HH:mm');
        resRequestData.popupTitle = 'Urejanje interne rezervacije';
        resRequestData.selectedAsset = term.asset;
        resRequestData.termComment = term.comment;
        resRequestData.genericTitle = term.title;
        resRequestData.customTagId = term.customTagId;
        if (resource && resource.id) {
            resRequestData.selectedSubcontractor = _.get(this.settings, 'filter.selectedSubcontractors').find(el => el.id == resource.id);
        } else {
            resRequestData.selectedSubcontractor = _.get(term, 'contractor.subcontractors[0]');
        }
        if (term.recurringId) {
            resRequestData.oldEvent = term.oldEvent;
        }

        modalNewTerm.componentInstance.resRequestData = resRequestData;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private editRegularReservation(modalNewTerm: NgbModalRef, term: any, resource: any): void {
        const resRequestData: ReservationRequest = new ReservationRequest();
        if (term?.reservationMode) {
            resRequestData.reservationMode = term.reservationMode;
        } else {
            resRequestData.reservationMode = ReservationMode.RESERVE;
        }
        resRequestData.event = new Event().deserialize(term);
        resRequestData.isEditMode = true;
        resRequestData.selectedDate = term.start;
        resRequestData.selectedTime = moment(term.start).format('HH:mm');
        resRequestData.selectedTimeEnd = moment(term.end).format('HH:mm');
        resRequestData.customerForTerm = new Customer().deserialize(term.customer);
        resRequestData.customTagId = term.customTagId;

        if (term?.reservationMode === ReservationMode.DRAFT) {
            resRequestData.popupTitle = 'Urejanje osnutka rezervacije';
        } else {
            resRequestData.popupTitle = 'Urejanje rezervacije';
        }

        if (!_.isNil(term.asset)) {
            resRequestData.selectedAsset = _.get(term, 'asset');
        }
        resRequestData.termComment = term.comment;
        if (resource && resource.id) {
            resRequestData.selectedSubcontractor = this.settings.subconstractors.find(el => el.id == resource.id);
        } else if (this.settings.filter.showResources && !(resource && resource.id) && _.get(term, 'newResource')) {
            // priključena razpoložljivost + premikaš termin iz enega podizvajalca na drugega
            resRequestData.selectedSubcontractor = _.get(term, 'newResource');
            // resRequestData.selectedService = undefined;
            resRequestData.selectedService = _.get(term, 'service', undefined);
        } else {
            resRequestData.selectedSubcontractor = _.get(term, 'contractor.subcontractors[0]', undefined);
            resRequestData.selectedService = _.get(term, 'service', undefined);
        }
        if (term.recurringId) {
            //če je ponavljajoč --> dodaj originalen termin zraven
            resRequestData.oldEvent = term.oldEvent;
        }
        if (!_.isEmpty(term.serviceGroup)) {
            resRequestData.serviceGroup = term.serviceGroup;
            resRequestData.serviceGroup.type = 'GROUP';
        }
        resRequestData.telemed = _.get(term, 'telemed', undefined);
        modalNewTerm.componentInstance.resRequestData = resRequestData;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public loadBackgroundColorForResorceWH(subconstractorsWH: any[], start: moment.Moment, end: moment.Moment): void {
        const startcopy: moment.Moment = start.clone();

        subconstractorsWH.map(sub => {
            const subcontracor: Contractor = this.settings.subconstractors ? this.settings.subconstractors.find(sc => sc.id == sub.id) : undefined;
            const calendarApi = this.calendarComponent.getApi();
            const backgroundEvents = [];
            const allAssetIds = this.allAssets ? this.allAssets.map(el => el.id) : [];
            while (start.isBefore(end)) {
                sub.businessHours.map(bh => {
                    if (bh.daysOfWeek[0] === start.isoWeekday()) {
                        // TODO Ignored with eslint-interactive on 2023-11-10
                        // eslint-disable-next-line prefer-const
                        let starWH = bh.startTime.split(':'),
                            // TODO Ignored with eslint-interactive on 2023-11-10
                            // eslint-disable-next-line prefer-const
                            endwH = bh.endTime.split(':'),
                            color = _.get(subcontracor, 'bgColor', '#d0d0d0'),
                            // TODO Ignored with eslint-interactive on 2023-11-10
                            // eslint-disable-next-line prefer-const
                            className = '';

                        if (color === null) {
                            color = '#d0d0d0';
                        }
                        // if (bh.openForExternal && bh.openForExternalCustomer) {
                        //     className = 'mf-external-availability-event';
                        // } else if (!bh.openForExternal && bh.openForExternalCustomer) {
                        //     className = 'mf-customer-availability-event';
                        // } else if (bh.openForExternal && !bh.openForExternalCustomer) {
                        //     className = 'mf-availability-event';
                        // }
                        const dateStart = moment(start).utc().add(1, 'days').set({ hour: starWH[0], minute: starWH[1] }).format('YYYY-MM-DDTHH:mm');

                        const dateEnd = moment(start).utc().add(1, 'days').set({ hour: endwH[0], minute: endwH[1] }).format('YYYY-MM-DDTHH:mm');

                        this.allEventsCount++;
                        if (bh.assetId == -1 || allAssetIds.includes(bh.assetId)) {
                            backgroundEvents.push({
                                id: 'mf-resources-all',
                                start: dateStart,
                                end: dateEnd,
                                backgroundColor: color,
                                resourceId: sub.id,
                                className: className,
                                display: 'background',
                                // render: 'background',
                                bsids: bh.bsids,
                                virtualReadiness: bh?.virtualReadiness,
                                virtualOrdered: bh?.virtualOrdered,
                                openForExternal: bh?.openForExternal,
                                openForExternalCustomer: bh?.openForExternalCustomer,
                                services: bh?.services,
                            });
                        }
                    }
                });
                start.add(1, 'days');
            }
            calendarApi.batchRendering(function () {
                backgroundEvents.forEach(event => {
                    calendarApi.addEvent(event);
                });
            });
            start = startcopy.clone();
        });
    }

    private navigateToTerm(
        prereservation: string,
        isNewTab: boolean = false,
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        customerId: any,
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        visitId: any,
        telemed: boolean,
        phoneCall: boolean,
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        termType?: any,
        originUrl?: string,
    ): void {
        let path = '';
        if (
            this.am.isAM(AppModulesType.HELLO_DOCTOR) &&
            (this.mta.isMTA(termType) || originUrl === 'G100_01' || originUrl === 'G100_03' || originUrl === 'LAIF') &&
            (telemed || phoneCall)
        ) {
            if (!visitId) {
                this.createVisit(prereservation, customerId);
            }
            path = `calendar/selected/hd/${prereservation}`;
        } else {
            path = `calendar/selected/${prereservation}`;
        }
        if (isNewTab) {
            window.open(path, '_blank');
        } else {
            this.route.navigate([path]);
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public removeNonWorkingSubContractors(wh: any): any[] {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any[] = [];
        wh.map(el => {
            for (const bh of el.businessHours) {
                if (bh.start !== '00:00' && bh.end !== '00:00') {
                    res.push(el);
                    return;
                }
            }
        });
        return res;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public removeExternalAvailability(wh: any, showBothExternal: boolean = false): any[] {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wh.map((el: any) => {
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            el.businessHours = el.businessHours.filter((bh: any) =>
                !showBothExternal ? !bh.openForExternal : !bh.openForExternal || (bh.openForExternal && bh.openForExternalCustomer),
            );
        });

        return wh;
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public removeExternalCustomerAvailability(wh: any, showBothExternal: boolean = false): any[] {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wh.map((el: any) => {
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            el.businessHours = el.businessHours.filter((bh: any) =>
                !showBothExternal ? !bh.openForExternalCustomer : !bh.openForExternalCustomer || (bh.openForExternal && bh.openForExternalCustomer),
            );
        });

        return wh;
    }

    public reloadEvents(refetchEvents: boolean = true, refetchResources: boolean = true): void {
        this.allEventsCount = 0;
        if (this.calendarComponent) {
            const calendarApi = this.calendarComponent.getApi();
            if (refetchEvents) {
                calendarApi?.refetchEvents();
            }
            if (refetchResources) {
                calendarApi?.refetchResources();
            }
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public loadWorkingHours(selectedSubconstractors: Contractor[], start: moment.Moment, end: moment.Moment): Observable<any> {
        this.disableButtons(true);
        return forkJoin(
            selectedSubconstractors.map(subcon => {
                return this.settingsRest
                    .getWorkingHours(this.storage.getSelectedContractor().id, subcon.id, start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'))
                    .pipe(
                        map(rules => {
                            const result = {
                                id: subcon.id,
                                title: subcon.name,
                                businessHours: [],
                            };
                            if (!_.isNil(rules.overridenWorkingHours)) {
                                rules.overridenWorkingHours.map(el => {
                                    if (el.active && el.workingIntervals.length > 0) {
                                        el.workingIntervals.map(intrvl => {
                                            result.businessHours.push({
                                                daysOfWeek: [moment(el.date).isoWeekday()],
                                                startTime: moment(intrvl.start).format('HH:mm'),
                                                endTime: moment(intrvl.end).format('HH:mm'),
                                                openForExternal: intrvl.openForExternal,
                                                openForExternalCustomer: intrvl.openForExternalCustomer,
                                                assetId: intrvl.assetId,
                                                bsids: intrvl.bsids,
                                                virtualReadiness: intrvl?.virtualReadiness,
                                                virtualOrdered: intrvl?.virtualOrdered,
                                                services: intrvl?.services,
                                            });
                                        });
                                    }
                                });
                            }
                            //TOLE POMOJE NE RABIMO VEČ
                            if (!_.isNil(rules.defaultWorkingHours)) {
                                rules.defaultWorkingHours.map(el => {
                                    if (el.active && el.workingIntervals.length > 0) {
                                        el.workingIntervals.map(intrvl => {
                                            result.businessHours.push({
                                                daysOfWeek: [this.helper.weekDayNameToNumber(el.dayOfWeek)],
                                                startTime: moment(intrvl.start).format('HH:mm'),
                                                endTime: moment(intrvl.end).format('HH:mm'),
                                                openForExternal: intrvl.openForExternal,
                                                openForExternalCustomer: intrvl.openForExternalCustomer,
                                                assetId: intrvl.assetId,
                                                bsids: intrvl.bsids,
                                                virtualReadiness: intrvl?.virtualReadiness,
                                                virtualOrdered: intrvl?.virtualOrdered,
                                            });
                                        });
                                    }
                                });
                            }
                            return result;
                        }),
                    );
            }),
        );
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onEventRenderSetClassName(data): any {
        if (this.textSearch) {
            if ((<string>data.event?.title).toUpperCase().includes(this.textSearch.toUpperCase())) {
                return [];
            } else {
                return ['hidde-search'];
            }
        }
        return [];
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onEventRender(data: any): void {
        this.allEventsCount++;
        this.removePopover();
        //background event
        if (data?.event?.display == 'background') {
            // skrijem razpoložljivost če jo imam izključeno v filtrih
            if (!this.settings.filter.showResources) {
                data.el.hidden = 'true';
                this.allEventsCount--;
            } else {
                this.guiHelper.generateBackgroundEventRender(data.el, data.event.extendedProps);
            }
            return;
        }
        //interni event
        if (data?.event?.extendedProps?.data?.title) {
            //interna rezervacija
            $(data.el).popover(this.guiHelper.generateGenericPopupContent(data));
            data.el = this.guiHelper.generateGenericEventRender(data.el, _.get(data, 'event.extendedProps.data'), data.view);
        } else {
            //normalna rezervacija
            if (
                data.view.type == 'timeGridWeek' ||
                data.view.type == 'resourceTimeGridWeek' ||
                data.view.type == 'dayGridMonth' ||
                data.view.type == 'resourceTimeGridDay' ||
                data.view.type == 'timeGridDay'
            ) {
                $(data.el).popover(
                    this.guiHelper.generatePopupContent(
                        data,
                        _.get(this.settings, 'subconstractors', []),
                        _.get(this.settings, 'filter.selectedAssets', []),
                    ),
                );

                //TODO if (!(data.event instanceof HolidayEvent)) {
                //     $(data.el).popover(
                //         this.guiHelper.generatePopupContent(
                //             data,
                //             _.get(this.settings, 'subconstractors', []),
                //             _.get(this.settings, 'filter.selectedAssets', []),
                //         ),
                //     );
                // }
            }

            this.guiHelper.generateEventRender(data.el, data.event.extendedProps.data, _.get(this.settings, 'subconstractors', []), data.view);
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onEventResourceRender(data: any): void {
        $(data.el).tooltip({ title: data.resource.title, placement: 'auto' });
        // $(data.resource._context.calendarApi.el).tooltip({ title: data.resource.title });
        if (this.settings.subconstractors.length > 3) {
            this.localHelper.manageResourceHeader(data.resource, data.el);
        }
    }

    // public onEventResourceRender(data: any) {
    //     $(data.el).tooltip({ title: data.resource.title });
    //     if (this.selectedAssets.length > 2) {
    //         data.el.innerHTML = this.assetStringPipe.transform(data.resource.title);
    //     }
    // }

    public popupStatus(popupOpened: boolean): void {
        this.popupOpened = popupOpened;
    }
    public saveCalendarRange(info): void {
        if (this.loggedUser) {
            this.loggedUser.settings.calendarFrom = info.view.activeStart;
            this.loggedUser.settings.selectedCalendarView = info.view.type;
            this.storage.setUserData(this.loggedUser);
        }
    }

    public filterEvents(text: string): void {
        this.textSearch = text;
        const calendarApi = this.calendarComponent.getApi();

        // let c = calendarApi.getEvents();
        // c = c.slice(10, 35);
        // calendarApi.removeAllEvents();
        // c.map((el) => calendarApi.addEvent(el));
        calendarApi.render();
        // calendarApi.batchRendering(() => {});
        // calendarApi.refetchEvents();
    }

    public createVisit(prereserationId, customerId): void {
        this.visitRest
            .createVisitFromPrereservation(prereserationId, customerId)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
                res => {},
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
                error => {},
            );
    }
}
